import * as React from "react";
import { forwardRef } from "react";
const SvgAngleDown = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", width: "1em", height: "1em", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }), /* @__PURE__ */ React.createElement("path", { d: "M5.1 6l6.9 6.9L18.9 6 21 8.1l-9 9-9-9z" }));
const ForwardRef = forwardRef(SvgAngleDown);
export default ForwardRef;
